module.exports = __webpack_public_path__ + "static/img/bg-5.978e6f14.png";